export default __webpack_public_path__ + "static/media/2yearslogo.542f3410.png";